import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SubscriptionSkeleton = () => {
  return (
    <div className="wsp-page">

      {/* Header */}
      <div className="wsp-header-back">
        <Skeleton width={42} height={42} borderRadius={12} />
        <Skeleton width={170} height={24} />
      </div>

      {/* Hero */}
      <div className="wsp-hero">
        <Skeleton width={150} height={32} />
        <Skeleton width={240} height={36} style={{ marginTop: 15 }} />
        <Skeleton width={420} height={18} style={{ marginTop: 15 }} />
        <Skeleton width={320} height={18} style={{ marginTop: 8 }} />
      </div>

      {/* Cards */}
      <div className="wsp-grid">
        {[1, 2, 3].map((item) => (
          <div className="wsp-card" key={item}>

            <div className="wsp-card__top">
              <Skeleton circle width={46} height={46} />
              <Skeleton width={80} height={28} borderRadius={20} />
            </div>

            <Skeleton width="60%" height={24} />

            <Skeleton
              width="45%"
              height={30}
              style={{ marginTop: 15 }}
            />

            <div className="wsp-card__divider" />

            {[1, 2, 3, 4].map((i) => (
              <Skeleton
                key={i}
                height={16}
                style={{ marginBottom: 12 }}
              />
            ))}

            <Skeleton
              height={45}
              borderRadius={12}
              style={{ marginTop: 20 }}
            />

          </div>
        ))}
      </div>

      <div className="wsp-footer-note">
        <Skeleton width={220} height={18} />
      </div>

    </div>
  );
};

export default SubscriptionSkeleton;